const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api'

// Get all products from the backend
export const getProducts = async () => {
  try {
    const response = await fetch(`${API_URL}/Shop`)
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    const data = await response.json()
    return data
  } catch (error) {
    console.error('Error fetching products:', error)
    throw error
  }
}

// Get a single product by ID
export const getProductById = async (id) => {
  try {
    const response = await fetch(`${API_URL}/Shop/${id}`)
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    const data = await response.json()
    return data
  } catch (error) {
    console.error('Error fetching product:', error)
    throw error
  }
}

// Helper function to get product data (maintains compatibility with existing code)
export const GetProductData = (id) => {
  // This function will be deprecated once we fully migrate to API calls
  // For now, it can be used as a fallback or for specific use cases
  return getProductById(id)
}
